import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import Tabs from '../components/tabs';

const SimpleTabsContainer = createReactClass({
  getDefaultProps() {
    return {
      className: '',
      direction: 'horizontal',
      initialTabId: '',
      onClick: () => {},
      queryParamsToPersist: [],
      shouldRenderAll: true,
      tabs: [],
      variant: 'admin',
    };
  },

  getInitialState() {
    const { initialTabId, tabs } = this.props;

    const hashId = window.location.hash.substring(1);

    return { activeId: initialTabId || hashId || tabs[0]?.id };
  },

  onClick(id) {
    this.setState({ activeId: id });
    this.props.onClick(id);
  },

  render() {
    const {
      className,
      direction,
      queryParamsToPersist,
      shouldRenderAll,
      tabs,
      variant,
    } = this.props;

    return (
      <Tabs
        activeId={this.state.activeId}
        className={className}
        isVertical={direction === 'vertical'}
        onClick={this.onClick}
        queryParamsToPersist={queryParamsToPersist}
        shouldRenderAll={shouldRenderAll}
        tabs={tabs}
        variant={variant}
      />
    );
  },
});

SimpleTabsContainer.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  initialTabId: PropTypes.string,
  onClick: PropTypes.func,
  queryParamsToPersist: PropTypes.arrayOf(PropTypes.string),
  shouldRenderAll: PropTypes.bool,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    body: PropTypes.node,
  })),
  variant: PropTypes.oneOf(['admin', 'student']),
};

export default SimpleTabsContainer;
